import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';

import { alert } from '@services/alert';
import { generateDataUrl } from '@utils/generate-data-url';

import Spinner from '@components/Spinner.vue';

import { faTimes } from '@icons/regular/faTimes';
import { faImage } from '@icons/duotone/faImage';

/**
 * `FormFileDrop` component properties.
 */
export interface Props {
  value: File | null;
}

/**
 * `FormFileDrop` component emits.
 */
export type Emits = (event: 'input', value: File | null) => void;


declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    FormFileDrop: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'FormFileDrop' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((event: 'input', value: File | null) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: File | null;
};




const loading = ref(false);
const dragging = ref(false);

const dataUrl = ref<string | null>(null);

watch(
  () => props.value,
  async (value: File | null) => {
    if (!value) {
      dataUrl.value = null;

      return;
    }

    loading.value = true;

    dataUrl.value = await generateDataUrl(value);

    loading.value = false;
  },
);

const showPreview = computed(() => {
  return !!dataUrl.value || loading.value;
});

function removeImage() {
  emit('input', null);
}

async function addFile() {
  const file = await addImageDialog();

  if (!file) return;

  emit('input', file);
}

async function onDrop({ dataTransfer }: DragEvent) {
  dragging.value = false;

  const file = dataTransfer?.files.item(0) ?? null;

  if (!file) return;

  console.log(file.type);

  if (!/^image\/(jpg|jpeg|png|gif|tiff)$/.test(file.type)) {
    return alert.error('The file you tried to add was not an image.');
  }

  emit('input', file);
}

//#region Helper Functions

/**
 * Prompt the user for an image file using the native file system dialog.
 *
 * @returns Image file data, if an image file was selected.
 */
async function addImageDialog() {
  const el = document.createElement('input');
  el.setAttribute('type', 'file');
  el.setAttribute('hidden', 'true');
  el.setAttribute('accept', 'image/png, image/jpeg, image/gif, image/tiff');

  document.body.append(el);

  const target = await new Promise<unknown>((resolve) => {
    el.oninput = ({ target }) => resolve(target);

    el.click();
  });

  el.remove();

  return target instanceof HTMLInputElement
    ? target.files?.item(0) ?? null
    : null;
}

//#endregion Helper Functions

return { __sfc: true,props, emit, loading, dragging, dataUrl, showPreview, removeImage, addFile, onDrop, addImageDialog, Spinner, faTimes, faImage }
}

})